/* eslint-disable import/no-anonymous-default-export */
export default [
  "AWS Certified Solutions Architect – Associate (Dec'21 - Dec'24)",
]